import React, { Component } from 'react';

import Conteudo from '../../Conteudo';
import Title from '../../components/Title';

import AuthProvider from '../../AuthProvider';

import CadastroProblema from './Cadastro';
import ListaMeusRegistros from './ListaMeusRegistros';

export default class extends Component {
  render () {
    return (
      <div>
        <Title value="Diego Rivera » Reportar problema" />
        <AuthProvider>
          {(_undefined, containsRole) => {
            let children = [];

            if (
              containsRole([
                'admin',
                'conselheiro',
                'sindico',
                'porteiro',
                'zelador',
                'morador',
                'proprietario'
              ])
            ) {
              children.push(ListaMeusRegistros, CadastroProblema);
            }

            return (
              children.length && (
                <Conteudo>
                  {children.map((Child, i) => (
                    <Child key={i} />
                  ))}
                </Conteudo>
              )
            );
          }}
        </AuthProvider>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/modules/problema/Index.js